var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.376695 8.94063C-0.125565 9.52657 -0.125565 10.4781 0.376695 11.0641L6.80563 18.5641C7.30789 19.15 8.12356 19.15 8.62582 18.5641C9.12808 17.9781 9.12808 17.0266 8.62582 16.4406L4.38674 11.5H16.7142C17.4254 11.5 18 10.8297 18 10C18 9.17032 17.4254 8.50001 16.7142 8.50001H4.39076L8.6218 3.55938C9.12406 2.97344 9.12406 2.02188 8.6218 1.43594C8.11954 0.850006 7.30387 0.850006 6.80161 1.43594L0.372677 8.93594L0.376695 8.94063Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSolid);
export default __webpack_public_path__ + "static/media/arrow-left-solid.66fd0e486f0a06e3f0407e82cc892153.svg";
export { ForwardRef as ReactComponent };